import script from "./MOTDToast.vue?vue&type=script&setup=true&lang=js"
export * from "./MOTDToast.vue?vue&type=script&setup=true&lang=js"

import "./MOTDToast.vue?vue&type=style&index=0&id=dd56cf80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd56cf80"]])

export default __exports__